export default "__VITE_ASSET__Cv14TdRP__"